export default "/bundles/assets/otracom-logo_d93fb6d7aa0cebb59151606fbf34ee80.png";